import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class RateAdapter extends ApplicationV1Adapter {}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    rate: RateAdapter;
  }
}
